export enum VerificationStepStatus {
    NOT_STARTED = 'NOT_STARTED',
    STARTED = 'STARTED',
    IN_REVIEW = 'IN_REVIEW',
    WARNING = 'WARNING',
    COMPLETED = 'COMPLETED',
    REJECTED = 'REJECTED',
    REDO = 'REDO',
}
